import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React, { useState, useCallback, Fragment } from 'react';
export function TreeView(_ref) {
  var items = _ref.items,
    _ref$getInitialExpand = _ref.getInitialExpandedItemIds,
    getInitialExpandedItemIds = _ref$getInitialExpand === void 0 ? function () {
      return [];
    } : _ref$getInitialExpand,
    renderTreeItem = _ref.children;
  var _useState = useState(getInitialExpandedItemIds),
    _useState2 = _slicedToArray(_useState, 2),
    expandedItemIds = _useState2[0],
    setExpandedItemIds = _useState2[1];
  var toggleExpansion = useCallback(function (itemId) {
    setExpandedItemIds(function (prevState) {
      return prevState.includes(itemId) ? prevState.filter(function (id) {
        return id !== itemId;
      }) : [].concat(_toConsumableArray(prevState), [itemId]);
    });
  }, []);
  var renderTree = function renderTree(items) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return items.map(function (item) {
      var _item$children;
      var hasChildren = ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0 || false;
      var isExpanded = hasChildren && expandedItemIds.includes(item.id);
      var treeItem = renderTreeItem({
        item: item,
        hasChildren: hasChildren,
        nestingLevel: level,
        isExpanded: isExpanded,
        onToggleIsExpanded: toggleExpansion
      });
      if (hasChildren) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: item.id
        }, treeItem, /*#__PURE__*/React.createElement("div", {
          role: "group",
          hidden: !isExpanded
        }, renderTree(item.children, level + 1)));
      }
      return treeItem;
    });
  };
  return /*#__PURE__*/React.createElement("div", null, renderTree(items));
}
export { default as TreeViewItem } from './TreeViewItem';